import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getHotArticles, siteInfo } from "@/utils/content";

export default function Footer() {
  const hot = getHotArticles(4);

  return (
    <footer className="w-full bg-secondary-800 text-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-brand text-[15px] leading-none text-background-50">
                511
              </span>
              <span className="font-heading text-lg font-bold text-background-50">511爆料</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-100">{siteInfo.intro}</p>
            <p className="mt-4 text-sm text-secondary-200">
              <i className="ri-mail-line mr-1 align-middle" />
              {siteInfo.email}
            </p>
          </div>

          <nav aria-label="分类导航">
            <h2 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">分类快速直达</h2>
            <ul className="mt-4 space-y-3 text-sm">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link to={`/category/${item.slug}`} className="text-secondary-100 transition-colors hover:text-background-50">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="热门爆料">
            <h2 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">正在热传</h2>
            <ul className="mt-4 space-y-3 text-sm">
              {hot.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/article/${item.id}`}
                    className="line-clamp-1 text-secondary-100 transition-colors hover:text-background-50"
                    title={item.title}
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="站点导航">
            <h2 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">站点</h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-secondary-100 transition-colors hover:text-background-50">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-secondary-100 transition-colors hover:text-background-50">
                  全部爆料
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-secondary-100 transition-colors hover:text-background-50">
                  常见问答
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-100 transition-colors hover:text-background-50">
                  关于我们
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 511爆料 · 内容为社区观察记录，人物与场景均为虚构。</p>
          <p>{siteInfo.slogan}</p>
        </div>
      </div>
    </footer>
  );
}